import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { buildSigninUrl } from '../newsintelligence/support/openDiscussions';
import { StorageBoxRouteSkeleton } from '../layout/ReusableComponent/Skeleton/RouteSkeletons';
import '../layout/ReusableComponent/Skeleton/RouteSkeletons.css';
import { useSessionAuth } from '../utils/SessionAuthContext';
import { markSessionValid } from '../utils/sessionAuth';

/** Owner StorageBox: skeleton until session is confirmed; sign-in only when truly logged out. */
export default function StorageBoxAuthGate({ children }) {
  const location = useLocation();
  const { status, refreshSession } = useSessionAuth();
  const [guestConfirmed, setGuestConfirmed] = useState(false);

  useEffect(() => {
    if (status !== 'guest') {
      setGuestConfirmed(false);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      const ok = await refreshSession({ force: true });
      if (cancelled) return;
      if (ok) {
        markSessionValid();
      } else {
        setGuestConfirmed(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [status, refreshSession]);

  if (status === 'authenticated') {
    return children;
  }

  if (status === 'unknown' || (status === 'guest' && !guestConfirmed)) {
    return <StorageBoxRouteSkeleton />;
  }

  const returnTo = `${location.pathname}${location.search}`;
  return <Navigate to={buildSigninUrl({ returnTo })} replace />;
}
